import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { Mowing } from "../models/MowingModels";
import { SCSData } from "@abaco/supply-chain-view-module/src/modules/supply-chain-view-module/models/SCSModels";

import { BlockMappedDataWithId } from "../models/MowingModels";

export default class MowingApi {
    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    public async getMowingData(block: number, from: Date, to: Date): Promise<Mowing[]>
    {
        const res = await this.http.get(`/mowing/api/v1/block/${block}`, { params: {
            from: from.toISOString().split('T')[0],
            to: to.toISOString().split('T')[0]
        }})

        return res.data

        // return [
        //     {
        //     "externalId": 263787,
        //     "index": "evi2",
        //     "date": "2021-11-24",
        //     "count": 912,
        //     "min": 0.092552624642849,
        //     "max": 0.186875268816948,
        //     "sum": 120.847903080285,
        //     "stdDev": 0.0228508747054395,
        //     "mean": 0.132508665658207,
        //     "alarm": false
        // }, {
        //     "externalId": 263787,
        //     "index": "evi2",
        //     "date": "2021-10-28",
        //     "count": 912,
        //     "min": 0.0269452389329672,
        //     "max": 0.0798389837145805,
        //     "sum": 42.5799147151411,
        //     "stdDev": 0.0117916024322939,
        //     "mean": 0.0466885029771284,
        //     "alarm": false
        // }, {
        //     "externalId": 263787,
        //     "index": "evi2",
        //     "date": "2021-10-18",
        //     "count": 912,
        //     "min": 0.0848640874028206,
        //     "max": 0.135734766721725,
        //     "sum": 95.7484742701054,
        //     "stdDev": 0.00959130374146937,
        //     "mean": 0.104987362138273,
        //     "alarm": true
        // }, {
        //     "externalId": 263787,
        //     "index": "evi2",
        //     "date": "2021-10-15",
        //     "count": 912,
        //     "min": 0.0961587429046631,
        //     "max": 0.16795526444912,
        //     "sum": 109.734058581293,
        //     "stdDev": 0.0129502251545327,
        //     "mean": 0.120322432654926,
        //     "alarm": false
        // }, {
        //     "externalId": 263787,
        //     "index": "evi2",
        //     "date": "2021-10-13",
        //     "count": 912,
        //     "min": 0.0931351855397224,
        //     "max": 0.152780339121819,
        //     "sum": 105.400085002184,
        //     "stdDev": 0.012361575831455,
        //     "mean": 0.115570268642746,
        //     "alarm": false
        // }, {
        //     "externalId": 263787,
        //     "index": "evi2",
        //     "date": "2021-10-10",
        //     "count": 912,
        //     "min": 0.101140514016151,
        //     "max": 0.178471222519875,
        //     "sum": 122.266690135002,
        //     "stdDev": 0.0185745580104609,
        //     "mean": 0.134064353218204,
        //     "alarm": false
        // }, {
        //     "externalId": 263787,
        //     "index": "evi2",
        //     "date": "2021-10-03",
        //     "count": 912,
        //     "min": 0.0892102643847466,
        //     "max": 0.18674136698246,
        //     "sum": 119.131089061499,
        //     "stdDev": 0.0231667719897527,
        //     "mean": 0.13062619414638,
        //     "alarm": true
        // }, {
        //     "externalId": 263787,
        //     "index": "evi2",
        //     "date": "2021-09-30",
        //     "count": 912,
        //     "min": 0.103348910808563,
        //     "max": 0.207174941897392,
        //     "sum": 135.695282898843,
        //     "stdDev": 0.0236085592375748,
        //     "mean": 0.148788687389083,
        //     "alarm": false
        // }, {
        //     "externalId": 263787,
        //     "index": "evi2",
        //     "date": "2021-09-20",
        //     "count": 912,
        //     "min": 0.17108428478241,
        //     "max": 0.352286696434021,
        //     "sum": 235.963448807597,
        //     "stdDev": 0.0437685121196762,
        //     "mean": 0.258731851762716,
        //     "alarm": false
        // }, {
        //     "externalId": 263787,
        //     "index": "evi2",
        //     "date": "2021-09-18",
        //     "count": 912,
        //     "min": 0.188974067568779,
        //     "max": 0.353454291820526,
        //     "sum": 246.012458428741,
        //     "stdDev": 0.0418121334996435,
        //     "mean": 0.269750502663093,
        //     "alarm": false
        // }, {
        //     "externalId": 263787,
        //     "index": "evi2",
        //     "date": "2021-09-13",
        //     "count": 912,
        //     "min": 0.258034348487854,
        //     "max": 0.496110141277313,
        //     "sum": 357.648643046618,
        //     "stdDev": 0.0613090748989511,
        //     "mean": 0.392158599831817,
        //     "alarm": false
        // }, {
        //     "externalId": 263787,
        //     "index": "evi2",
        //     "date": "2021-09-08",
        //     "count": 912,
        //     "min": 0.363508462905884,
        //     "max": 0.584510028362274,
        //     "sum": 458.110357642174,
        //     "stdDev": 0.0568378286854261,
        //     "mean": 0.502313988642734,
        //     "alarm": false
        // }, {
        //     "externalId": 263787,
        //     "index": "evi2",
        //     "date": "2021-09-05",
        //     "count": 912,
        //     "min": 0.423108696937561,
        //     "max": 0.628421545028687,
        //     "sum": 500.792237699032,
        //     "stdDev": 0.0534627047100932,
        //     "mean": 0.549114295722623,
        //     "alarm": false
        // }]
    }

    public async getBlocksByFarm(farm: number, campaign: number, plot: number): Promise<BlockMappedDataWithId[]>
    {
        const url = `/sitiagri-rest-api/api_basic/v1/plots/subjects/${farm}/${campaign}/blocks`;

        const req = await this.http.get(url , { params: {
            filter: `plot_id eq ${plot}`
        }})

        const toRet = req.data.records.map((el: SCSData) => {
            return {
                country: el.country,
                council_label: el.council_label,
                company_code: el.company_code,
                company_name: el.company_name,
                plot_name: el.plot_name,
                block_code: el.block_code,
                is_agreed: el.is_agreed ? 'hco-true' : 'hco-false',
                area_ha: el.area_ha,
                variety: el.variety,
                planting_year: el.planting_year,
                layout: el.layout,
                azimut: el.azimut,
                num_of_plants: el.num_of_plants,
                block_x: el.block_x,
                block_y: el.block_y,
                block_id: el.block_id
            }
        })

        req.data.records = toRet

        return req.data.records
    }
}
